import * as v from 'valibot';

import { vcGcid, vcOptionalWithNullToUndefined, vcUcid } from '../../../../utils/valibot/custom-types';
import { newSchema } from '../../../../utils/valibot/schema';

/**
 * Response of CDF's `POST gcdm/customers`.
 *
 * The UCID is returned by GCDM but not used by CDF: Retail CRM imports by GCID
 * (see CUSTAPP-611). It is kept in the schema so it shows up in logs.
 */
export const GcdmCreateCustomerResponseSchema = newSchema(
  'GcdmCreateCustomerResponseSchema',
  v.object({
    gcid: vcGcid,
    ucid: vcOptionalWithNullToUndefined(vcUcid),
  }),
);

export type GcdmCreateCustomerResponse = v.InferOutput<typeof GcdmCreateCustomerResponseSchema>;
